import { render, staticRenderFns } from "./NewsroomLandingPage.vue?vue&type=template&id=f72bc0c2"
import script from "./NewsroomLandingPage.vue?vue&type=script&lang=js"
export * from "./NewsroomLandingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports